<template>
   <el-form ref="formValidate" :model="params" label-width="136px" :rules="rules">
    <el-form-item prop="name" :label="$t('param.paramName')">
      <el-input type="text" v-model="params.name" :placeholder="$t('param.nameRequire')"></el-input>
    </el-form-item>
    <el-form-item prop="value" :label="$t('param.paramValue')">
        <el-input type="text" v-model="params.value" :placeholder="$t('param.valueRequire')"></el-input>
    </el-form-item>
    <el-form-item prop="type" :label="$t('param.paramType')">
        <el-input type="text" v-model="params.type" :placeholder="$t('param.typeRequire')"></el-input>
    </el-form-item>
    <el-form-item prop="status" :label="$t('param.paramStatus')">
      <zk-dictionary-select type="status" v-model="params.status"
      :placeholder="$t('common.select')"></zk-dictionary-select>
    </el-form-item>
    <el-form-item prop="remark" :label="$t('common.remark')">
        <el-input type="text" v-model="params.remark" :placeholder="$t('common.remarkRequire')"></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import * as optionsService from '../../../services/options'
export default {
  name: 'zk-sys-opt-save-or-update',
  props: ['form', 'isUpdate'],
  data () {
    let checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('common.statusRequire')))
      } else {
        callback()
      }
    }
    let rules = {
      type: [{ required: true, message: this.$t('param.typeRequire'), trigger: 'blur' }],
      name: [{ required: true, message: this.$t('param.nameRequire'), trigger: 'blur' }],
      value: [{ required: true, message: this.$t('param.valueRequire'), trigger: 'blur' }],
      status: [{ required: true, validator: checkStatus, trigger: 'blur' }]
    }
    return {
      params: JSON.parse(JSON.stringify(this.form || {})),
      rules
    }
  },
  methods: {
    save () {
      let _self = this
      return new Promise((resolve, reject) => {
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            if (!_self.isUpdate) {
              resolve(optionsService.add(_self.params))
            } else {
              resolve(optionsService.update(_self.params))
            }
          } else {
            reject(valid)
          }
        })
      })
    },
    resetFields () {
      this.$refs.formValidate.resetFields()
    }
  },
  watch: {
    form (newValue, oldValue) {
      this.params = JSON.parse(JSON.stringify(newValue || oldValue))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/systemOptSaveOrUpdate/src/main.vue